import * as Sentry from '@sentry/react';
import toast from 'react-hot-toast';
import { uploadLogo } from 'api/admin/businesses/businesses';

export const uploadLogoImage = async (event, setIsUploadingImage, setLogo) => {
  const file = event.target.files[0];
  if (file) {
    setIsUploadingImage(true);
    try {
      let formData = new FormData();
      formData.append('logo', file);
      const {
        data: { Location: logoUrl },
      } = await uploadLogo(formData);
      setLogo(logoUrl);
    } catch (error) {
      Sentry.captureException(error);
      toast.error('Failed to upload logo. Please try again.');
    } finally {
      setIsUploadingImage(false);
    }
  }
};
